<script setup>
import { VIconRender } from '@/modules/Signup/components';
import { computed, unref } from 'vue';
import successIcon from '@/modules/Signup/__clients/ezi/icons/circle-check.svg';
import dangerIcon from '@/modules/Signup/__clients/ezi/icons/circle-times.svg';
import whiteCheckIcon from '@/modules/Signup/__clients/ezi/icons/white-check.svg';
import { useSignUpModuleStore } from '@/stores/modules/signup/signUpStore';
import { storeToRefs } from 'pinia/dist/pinia';

const
    signUpStore = useSignUpModuleStore(),
    { searchResultIsAlternativeTechnology } = storeToRefs(signUpStore);

// eslint-disable-next-line no-undef
const props = defineProps({
    title: String,
    icon: {
        type: String,
        required: false,
    },
    severity: { // refer to severityIcons for available values
        type: String,
        required: false,
    },
});

const severityIcons = {
    success: successIcon,
    danger: dangerIcon,
};
const severityIcon = computed(() => severityIcons[props.severity] || null);

const severityTitleClass = computed(() => ({
    'tw-text-[#FF5064]': props.severity === 'danger',
    'tw-text-primary': props.severity === 'success' && unref(searchResultIsAlternativeTechnology),
    'tw-text-secondary': props.severity === 'success' && unref(!searchResultIsAlternativeTechnology),
}));

const contentClasses = computed(() => ({
    'success-triangle-width': unref(searchResultIsAlternativeTechnology),
    'tw-w-full': unref(!searchResultIsAlternativeTechnology),
}));
</script>

<template>
    <div
        class="tw-bg-white tw-mx-16 tw-my-16 tw-p-12 tw-h-[155px] tw-object-center tw-flex tw-items-center
        tw-justify-between tw-relative"
    >
        <div class="tw-flex tw-flex-col tw-gap-6" :class="contentClasses">
            <h4 class="!tw-text-[24px] !tw-font-semibold" :class="severityTitleClass" v-html="props.title"></h4>
            <slot />
        </div>

        <VIconRender v-if="severityIcon && !searchResultIsAlternativeTechnology" :icon-src="severityIcon" />
        <div v-else-if="searchResultIsAlternativeTechnology" class="success-triangle">
            <VIconRender :icon-src="whiteCheckIcon" />
        </div>
    </div>
</template>

<style scoped>
.success-triangle {
    @apply tw-pr-[50px] tw-pb-[40px] tw-flex tw-items-end tw-justify-end tw-w-[283px] tw-h-full tw-absolute tw-right-0;
    background: linear-gradient(135deg, #FF0090 0%, #FF7D90 100%);
    clip-path: polygon(0% 100%, 100% 0%, 100% 100%);
}

.success-triangle-width {
    width: calc(100% - 300px);
}
</style>
